
import BaseInput from '@voady/base-input'
import BaseTextarea from '@voady/base-textarea'
import BaseLabel from '@voady/base-label'
import BaseSelect from '@voady/base-select'

import Vue from 'vue'
import App from './App.vue'
import './plugins'
import router from './router'
import store from './store/index.js'
import { createProvider } from './vue-apollo'

Vue.component('BaseInput', BaseInput)
Vue.component('BaseTextarea', BaseTextarea)
Vue.component('BaseLabel', BaseLabel)
Vue.component('BaseSelect', BaseSelect)
Vue.config.productionTip = false
new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  render: h => h(App),
}).$mount('#app')
